import {REQUEST_PAYMENT_TYPE, REQUEST_PAYMENT_TYPE_FAILURE, REQUEST_PAYMENT_TYPE_SUCCESS} from "../../../constant/master/TransPaymentTypeConstant";

const initialState = {
    payment_type: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const paymentTypeReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_PAYMENT_TYPE:
            return {
                ...state,
                payment_type: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_PAYMENT_TYPE_SUCCESS:
            return {
                ...state,
                payment_type: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_PAYMENT_TYPE_FAILURE:
            return {
                ...state,
                payment_type: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
